import React from "react";

import Tooltip from "@material-ui/core/Tooltip";
import { SlSettings } from "react-icons/sl";


export default class SettingsCell extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  render() {
    let {} = this.state;

    return (
      <Tooltip title={this.props.tooltip} placement="top" arrow>
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          style={{ margin: 3 }}
          onClick={(e) => this.props.onSettingsClicked()}
        >
          <SlSettings size={16} />
        </a>
      </Tooltip>
    );
  }
}

SettingsCell.defaultProps = {
  tooltip: "Edit",
};
